module.exports = __webpack_public_path__ + "img/zlindex20.87a8032e.png";